import styled from "styled-components";

export const ProductWarranteeDetailContainerStyled = styled.div`
  padding: 20px 16px 104px 16px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .product_warranty_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .product_info_wrap {
      margin-bottom: 48px;
    }
    .product_more_item {
      padding: 12px 0px;
      ${({ theme }) => theme.COLORS.GRAT_1};
      border-top: 1px solid;
      &:first-child {
        margin-top: 4412px;
      }
    }
    .content2 {
      .arrow_next {
        font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      }
      .header_product_warranty {
        display: flex;
        justify-content: center;
      }
      .content_input {
        margin-bottom: 50px;
      }
    }
    .btn_sec {
      display: flex;
      flex: 1;
      padding: 0 42px;
      .btn_edit {
        width: 100%;
        max-width: 171px;
      }
    }
    .btn_add_sn {
      margin-top: 12px;
      margin-bottom: 48px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 60px 16px 104px 16px;
    .breadcrumb_layout {
      display: none;
    }
    .content2 {
      .header_product_warranty {
        padding: 0px;
        display: flex;
        justify-content: flex-start;
      }
      .content_input {
        padding: 0px;
      }
      .btn_sec {
        padding: 0px;
      }
    }
  }
`;
